import React, { Fragment } from "react";
import PageTitle from "../../Layout/AppMain/PageTitle";
import Loader from "react-loaders";
import { api, userService } from "../../_services";
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
  CustomInput,
  Input,
  Label,
} from "reactstrap";
import Moment from "react-moment";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { currencyFormatter } from "../../_services/currencyFormatter";
import download from "downloadjs";
import moment from "moment";
import DatePicker from "react-datepicker";
import GenerateInvoicesModal from "./GenerateInvoicesModal";
import { toast } from "react-toastify";
import QuickBooksLoadingModal from "../Intuit/QuickBooksLoadingModal";
import PushInvoicesToQuickbooksModal from "./PushInvoicesToQuickbooksModal";

import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

export const PersistentFilters = () => {
  const getStartDate = () => {
    let sd = localStorage.getItem("invoiceStartDateFilter");
    if (sd == undefined || sd == null || sd == "") {
      return moment().add(-30, "day").toDate();
    } else {
      return moment(sd).toDate();
    }
  };
  const setStartDate = (date) => {
    localStorage.setItem("invoiceStartDateFilter", moment(date).format());
  };

  const getEndDate = () => {
    let sd = localStorage.getItem("invoiceEndDateFilter");
    if (sd == undefined || sd == null || sd == "") {
      return moment().toDate();
    } else {
      return moment(sd).toDate();
    }
  };
  const setEndDate = (date) => {
    localStorage.setItem("invoiceEndDateFilter", moment(date).format());
  };

  const getPartnershipId = () => {
    let sd = localStorage.getItem("invoicePartnershipFilter");
    if (sd == undefined || sd == null || sd == "") {
      return -1;
    } else {
      return sd;
    }
  };
  const setPartnershipId = (id) => {
    localStorage.setItem("invoicePartnershipFilter", id);
  };

  const getOutstandingAmount = () => {
    let sd = localStorage.getItem("invoiceOutstandingAmountFilter");
    if (sd == undefined || sd == null || sd == "") {
      return -1;
    } else {
      return sd;
    }
  };
  const setOutstandingAmount = (amount) => {
    localStorage.setItem("invoiceOutstandingAmountFilter", amount);
  };

  const getInvoiceStatus = () => {
    let sd = localStorage.getItem("invoiceInvoiceStatusFilter");
    if (sd == undefined || sd == null || sd == "") {
      return -1;
    } else {
      return sd;
    }
  };
  const setInvoiceStatus = (status) => {
    localStorage.setItem("invoiceInvoiceStatusFilter", status);
  };

  const getReviewer = () => {
    let sd = localStorage.getItem("invoiceReviewerFilter");
    if (sd == undefined || sd == null || sd == "") {
      return "All Reviewers";
    } else {
      return sd;
    }
  };
  const setReviewer = (reviewer) => {
    localStorage.setItem("invoiceReviewerFilter", reviewer);
  };

  const clearAll = () => {
    localStorage.removeItem("invoiceStartDateFilter");
    localStorage.removeItem("invoiceEndDateFilter");
    localStorage.removeItem("invoicePartnershipFilter");
    localStorage.removeItem("invoiceOutstandingAmountFilter");
    localStorage.removeItem("invoiceInvoiceStatusFilter");
    localStorage.removeItem("invoiceReviewerFilter");
  };

  return {
    getStartDate,
    setStartDate,
    getEndDate,
    setEndDate,
    getReviewer,
    setReviewer,
    getInvoiceStatus,
    setInvoiceStatus,
    getOutstandingAmount,
    setOutstandingAmount,
    getPartnershipId,
    setPartnershipId,
    clearAll,
  };
};

function InvoiceList(props) {
  const persistentFilters = PersistentFilters();
  const history = useHistory();
  const currentUser = userService.getLoggedInUser();

  const [isLoading, setIsLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const [entityList, setEntityList] = useState([]);
  const [entity, setEntity] = useState(null);
  const [partnershipList, setPartnershipList] = useState([]);
  const [selectedPartnershipId, setSelectedPartnershipId] = useState(
    persistentFilters.getPartnershipId(),
  );
  const [selectedMatterId, setSelectedMatterId] = useState(-1);
  const [matterList, setMatterList] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [selectedEntityId, setSelectedEntityId] = useState(-1);
  const [invoiceGridList, setInvoiceGridList] = useState([]);
  const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState(
    persistentFilters.getInvoiceStatus(),
  );
  const [appliedFilters, setAppliedFilters] = useState({
    partnershipId: persistentFilters.getPartnershipId(),
    outstandingAmount: persistentFilters.getOutstandingAmount(),
    invoiceStatusId: persistentFilters.getInvoiceStatus(),
    reviewer: persistentFilters.getReviewer(),
    startDate: persistentFilters.getStartDate(),
    endDate: persistentFilters.getEndDate(),
    matterId: -1,
  });
  const [invoiceStatusList, setInvoiceStatusList] = useState([]);
  const [outstandingAmountFilter, setOutstandingAmountFilter] = useState(
    persistentFilters.getOutstandingAmount(),
  );
  const [startDate, setStartDate] = useState(persistentFilters.getStartDate());
  const [endDate, setEndDate] = useState(persistentFilters.getEndDate());
  const [showGenerateInvoicesModal, setShowGenerateInvoicesModal] =
    useState(false);
  const [reviewerList, setReviewerList] = useState([]);
  const [selectedReviewer, setSelectedReviewer] = useState(
    persistentFilters.getReviewer(),
  );
  const [
    showPushInvoicesToQuickBooksModal,
    setShowPushInvoicesToQuickBooksModal,
  ] = useState(false);
  const [isSyncingQuickBooks, setIsSyncingQuickBooks] = useState(false);
  const [quickBooksError, setQuickBooksError] = useState(null);

  const [invoiceNumberFilter, setInvoiceNumberFilter] = useState("");
  const hasLoadedInitialInvoices = useRef(false);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (
      !hasLoadedInitialInvoices.current &&
      partnershipList.length > 0 &&
      invoiceStatusList.length > 0
    ) {
      hasLoadedInitialInvoices.current = true;
      loadInvoices(appliedFilters, invoiceStatusList, partnershipList);
    }
  }, [partnershipList, invoiceStatusList]);

  useEffect(() => {
    loadMattersForPartnership(selectedPartnershipId);
  }, [selectedPartnershipId]);

  const loadData = async () => {
    let partnerships = [];
    if (currentUser.systemRoleId == 2) {
      let e = await api.getEntityById(currentUser.entityId);
      setEntity(e);
      partnerships = await api.getPartnershipListByEntityId(
        currentUser.entityId,
        currentUser.userId,
      );
    } else {
      partnerships = await api.getPartnershipListByInvoiceReviewerId(
        currentUser.userId,
      );
    }

    let statuses = await api.getInvoiceStatuses();
    setInvoiceStatusList([
      { invoiceStatusId: -1, name: "All Statuses" },
      ...statuses,
    ]);
    setPartnershipList(partnerships);
    // loadInvoices(
    //   [{ invoiceStatusId: -1, name: "All Statuses" }, ...statuses],
    //   partnerships,
    // );
  };

  const invoiceMatchesLocalFilters = (invoice, filters) => {
    const invoiceDate =
      invoice.startDate != null ? moment(invoice.startDate) : null;
    const selectedStart =
      filters.startDate != null ? moment(filters.startDate) : null;
    const selectedEnd =
      filters.endDate != null ? moment(filters.endDate) : null;

    const matchesPartnership =
      filters.partnershipId == -1 ||
      invoice.partnershipId == filters.partnershipId;
    const matchesStatus =
      filters.invoiceStatusId == -1 ||
      invoice.invoiceStatusId == filters.invoiceStatusId;
    const matchesOutstanding =
      filters.outstandingAmount == -1 ||
      (filters.outstandingAmount == 0
        ? Number(invoice.outstandingAmount) === 0
        : Number(invoice.outstandingAmount) > 0);
    const matchesReviewer =
      filters.reviewer == "All Reviewers" ||
      (invoice.reviewerList != null &&
        invoice.reviewerList.indexOf(filters.reviewer) > -1);
    const matchesMatter =
      filters.matterId == -1 ||
      invoice.matterIds?.split(",").some((z) => z == filters.matterId);

    const matchesStartDate =
      selectedStart == null ||
      invoiceDate == null ||
      invoiceDate.isSameOrAfter(selectedStart, "day");
    const matchesEndDate =
      selectedEnd == null ||
      invoiceDate == null ||
      invoiceDate.isSameOrBefore(selectedEnd, "day");

    return (
      matchesPartnership &&
      matchesStatus &&
      matchesOutstanding &&
      matchesReviewer &&
      matchesMatter &&
      matchesStartDate &&
      matchesEndDate
    );
  };

  const loadInvoices = (
    filters = appliedFilters,
    statuses = invoiceStatusList,
    partners = partnershipList,
  ) => {
    setIsLoading(true);
    if (currentUser.systemRoleId == 2) {
      let partnershipIds = getPartnershipIds(filters.partnershipId, partners);
      api
        .getInvoiceListByPartnershipsEntity(
          partnershipIds,
          currentUser.entityId,
          currentUser.entityRoleId,
          filters.invoiceStatusId,
          filters.outstandingAmount,
          filters.startDate,
          filters.endDate,
          currentUser.currencyId,
          true,
        )
        .then((data) =>
          loadInvoicesCallback(data, filters, statuses, partners),
        );
    } else {
      api
        .getInvoiceListByInvoiceReviewerId(
          currentUser.userId,
          filters.outstandingAmount,
          filters.startDate,
          filters.endDate,
        )
        .then((data) =>
          loadInvoicesCallback(data, filters, statuses, partners),
        );
    }
  };

  const getDistinctReviewers = (invoices) => {
    let reviewers = ["All Reviewers"];
    invoices.forEach((inv) => {
      if (
        inv.reviewerList !== undefined &&
        inv.reviewerList != null &&
        inv.reviewerList.length > 0
      ) {
        let rs = inv.reviewerList.split(",").map((x) => x.trim());
        rs.forEach((r) => {
          if (reviewers.find((x) => x === r) == undefined) {
            reviewers.push(r);
          }
        });
      }
    });
    return reviewers.sort((a, b) => (a > b ? 1 : -1));
  };

  const loadInvoicesCallback = (
    data,
    filters = appliedFilters,
    statuses = invoiceStatusList,
    partnersList = partnershipList,
  ) => {
    const filteredInvoices = data.filter((invoice) =>
      invoiceMatchesLocalFilters(invoice, filters),
    );
    let reviewers = getDistinctReviewers(data);
    let partners = [...partnersList];
    partners = partners
      .map((p) => {
        p.invoiceList = filteredInvoices.filter(
          (m) => m.partnershipId == p.partnershipId,
        );
        return p;
      })
      .filter((x) => x.invoiceList !== undefined && x.invoiceList.length > 0);
    setReviewerList(reviewers);
    setInvoiceList(filteredInvoices);
    setInvoiceGridList(partners);
    setIsLoading(false);
  };

  const buildInvoiceGridList = (invoices, partners) => {
    return partners
      .map((partnership) => {
        partnership.invoiceList = invoices.filter(
          (invoice) => invoice.partnershipId == partnership.partnershipId,
        );
        return partnership;
      })
      .filter((partnership) => partnership.invoiceList.length > 0);
  };

  const getPartnershipIds = (
    partnershipId = appliedFilters.partnershipId,
    partners = partnershipList,
  ) => {
    // If selectedPartnershipId is -1, return all partnership IDs as a comma-separated string
    if (parseInt(partnershipId) === -1) {
      return partners.map((x) => x.partnershipId).join(",");
    }
    return "" + partnershipId;
  };

  const onMatterSelectionChange = (e) => {
    let id = parseInt(e.target.value);
    // persistentFilters.setMatterId(id);
    setSelectedMatterId(id);
  };

  const onPartnerSelectionChange = (e) => {
    let id = parseInt(e.target.value);
    setSelectedPartnershipId(id);
  };

  const loadMattersForPartnership = (partnershipId) => {
    setMatterList([]);
    if (partnershipId != -1) {
      api
        .getMatterListByPartnershipIdEntityId(
          partnershipId,
          currentUser.entityId,
          currentUser.userId,
        )
        .then((data) => {
          if (!data.some((x) => x.matterId == selectedMatterId)) {
            setSelectedMatterId(-1);
          }
          setMatterList(data);
        });
    } else {
      setSelectedMatterId(-1);
    }
  };

  const onOutstandingAmountFilterChange = (e) => {
    setOutstandingAmountFilter(e.target.value);
  };

  const onSelectedInvoiceStatusChange = (e) => {
    setSelectedInvoiceStatus(e.target.value);
  };

  const onSelectedReviewerChange = (e) => {
    setSelectedReviewer(e.target.value);
  };

  const searchByInvoiceNumber = async () => {
    setIsLoading(true);
    try {
      let invoicesByNumber = await api.findInvoiceByNumber(
        invoiceNumberFilter,
        currentUser.entityId,
      );
      invoicesByNumber = Array.isArray(invoicesByNumber)
        ? invoicesByNumber
        : [];

      // const distinctPartnershipIds = [
      //   ...new Set(invoicesByNumber.map((invoice) => invoice.partnershipId)),
      // ];
      // const partnerships = await Promise.all(
      //   distinctPartnershipIds.map((partnershipId) =>
      //     api.getPartnershipById(partnershipId),
      //   ),
      // );

      setReviewerList(getDistinctReviewers(invoicesByNumber));
      setInvoiceList(invoicesByNumber);
      setInvoiceGridList(
        buildInvoiceGridList(invoicesByNumber, partnershipList),
      );
    } finally {
      setIsLoading(false);
    }
  };

  const onApplyFilters = () => {
    const nextFilters = {
      partnershipId: parseInt(selectedPartnershipId),
      outstandingAmount: parseInt(outstandingAmountFilter),
      invoiceStatusId: parseInt(selectedInvoiceStatus),
      reviewer: selectedReviewer,
      startDate,
      endDate,
      matterId: selectedMatterId,
    };

    persistentFilters.setPartnershipId(nextFilters.partnershipId);
    persistentFilters.setOutstandingAmount(nextFilters.outstandingAmount);
    persistentFilters.setInvoiceStatus(nextFilters.invoiceStatusId);
    persistentFilters.setReviewer(nextFilters.reviewer);
    persistentFilters.setStartDate(nextFilters.startDate);
    persistentFilters.setEndDate(nextFilters.endDate);

    setAppliedFilters(nextFilters);
    loadInvoices(nextFilters);
  };

  // Ensure loadInvoices is called after partnershipList is set for the first time
  // useEffect(() => {
  //   if (!isLoading && currentUser.systemRoleId == 2 && partnershipList && partnershipList.length > 0) {
  //     loadInvoices();
  //   }
  //   // eslint-disable-next-line
  // }, [partnershipList]);

  // --- Function body for InvoiceList component ---
  const quickbooksDisabled =
    entity?.quickBooksTokenInfo == undefined ||
    entity?.quickBooksTokenInfo == null ||
    entity?.quickBooksTokenInfo == "";
  const columns = [
    {
      dataField: "partnershipName",
      text: currentUser.entityRoleId == 1 ? "Law Firm" : "Client",
      sort: true,
      headerStyle: () => {
        return { width: "100%" };
      },
      formatter: (cell, row) => {
        return cell;
      },
    },
  ];

  const downloadLedesInvoice = (e, invoice) => {
    e && e.preventDefault();
    setIsDownloading(true);
    api.getLedesInvoice(invoice.invoiceId).then((blob) => {
      setIsDownloading(false);
      download(blob, `LedesInvoice_${invoice.invoiceNumber}.txt`);
    });
  };

  const downloadInvoiceReport = (e, invoice, reportType) => {
    e && e.preventDefault();
    setIsDownloading(true);
    api.getInvoicePdf(invoice.invoiceId, reportType).then((blob) => {
      setIsDownloading(false);
      download(
        blob,
        `Invoice_${invoice.invoiceNumber}.${reportType.toLowerCase()}`,
      );
    });
  };

  const toggleGenerateInvoicesModal = () => {
    setShowGenerateInvoicesModal((prev) => !prev);
  };

  const togglePushInvoicesToQuickBooksModal = () => {
    setShowPushInvoicesToQuickBooksModal((prev) => !prev);
  };

  const goToInvoice = (id) => {
    history.push({ pathname: `/invoice/${id}` });
  };

  const invoiceColumns = [
    {
      dataField: "invoiceNumber",
      text: "Invoice",
      sort: true,
      headerStyle: () => {
        return { width: "7%" };
      },
      formatter: (cellContent, row, rowIndex, extraData) => {
        return currentUser.entityRoleId == 2 ? (
          <Link to={`/invoice/${row.invoiceId}`}>{cellContent}</Link>
        ) : extraData ? (
          <Fragment>
            {cellContent}{" "}
            <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
          </Fragment>
        ) : (
          <a
            key={row.invoiceId}
            href="#"
            onClick={(e) => {
              downloadInvoiceReport(e, row, "PDF");
            }}
          >
            {cellContent}
          </a>
        );
      },
      formatExtraData: isDownloading,
    },
    {
      dataField: "invoiceId",
      text: "",
      sort: true,
      headerStyle: () => {
        return { width: "4%" };
      },
      formatter: (cellContent, row, rowIndex, extraData) => {
        return currentUser.entityRoleId == 2 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <a href="#" onClick={(e) => downloadLedesInvoice(e, row)}>
              Ledes
            </a>
            <span>/</span>
            <a href="#" onClick={(e) => downloadInvoiceReport(e, row, "PDF")}>
              PDF
            </a>
            <span>/</span>
            <a href="#" onClick={(e) => downloadInvoiceReport(e, row, "DOCX")}>
              Word
            </a>
            {extraData && (
              <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            )}
          </div>
        ) : (
          ""
        );
      },
      formatExtraData: isDownloading,
    },
    {
      dataField: "quickBooksInvoiceId",
      sort: true,
      text: "In QBO",
      headerStyle: () => {
        return { width: "5%" };
      },
      formatter: (cell, row) => {
        return row.quickBooksInvoiceId != undefined &&
          row.quickBooksInvoiceId != null &&
          row.quickBooksInvoiceId != ""
          ? "Yes"
          : "No";
      },
    },
    {
      dataField: "quickBooksDeliveryDate",
      text: "Delivery Date",
      sort: true,
      headerStyle: () => {
        return { width: "6%" };
      },
      formatter: (cellContent, row) => {
        return cellContent == undefined || cellContent == null ? (
          ""
        ) : (
          <Moment format="MM/DD/YYYY">{cellContent}</Moment>
        );
      },
    },
    {
      dataField: "matterList",
      text: "Matter(s)",
      sort: true,
      headerStyle: () => {
        return { width: "13%" };
      },
    },
    {
      dataField: "reviewerList",
      text: "Reviewer(s)",
      sort: true,
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "startDate",
      text: "Start Date",
      sort: true,
      headerStyle: () => {
        return { width: "7%" };
      },
      formatter: (cellContent, row) => {
        return <Moment format="MM/DD/YYYY">{cellContent}</Moment>;
      },
      // footer: columnData =>
      //     columnData.length > 0 ? new Date(columnData.reduce((prev, curr) => {
      //         return new Date(prev) > new Date(curr) ? curr : prev;
      //     })).toLocaleDateString() : ''
    },
    {
      dataField: "endDate",
      text: "End Date",
      sort: true,
      headerStyle: () => {
        return { width: "7%" };
      },
      formatter: (cellContent, row) => {
        return <Moment format="MM/DD/YYYY">{cellContent}</Moment>;
      },
      // footer: columnData =>
      //     columnData.length > 0 ? new Date(columnData.reduce((prev, curr) => {
      //         return new Date(prev) > new Date(curr) ? curr : prev;
      //     })).toLocaleDateString() : ''
    },
    {
      dataField: "invoiceTotal",
      sort: true,
      text: "Amount",
      headerStyle: () => {
        return { width: "7%" };
      },
      formatter: (cell, row) => {
        return currencyFormatter("$", cell, true);
      },
      //footer: columnData => currencyFormatter(this.currentUser.currencySymbol, columnData.reduce((acc, item) => acc + item, 0))
    },
    {
      dataField: "outstandingAmount",
      sort: true,
      text: "Outstanding Amount",
      headerStyle: () => {
        return { width: "8%" };
      },
      formatter: (cell, row) => {
        return currencyFormatter("$", cell, true);
      },
    },
    {
      dataField: "invoiceId",
      sort: true,
      text: "Payments",
      headerStyle: () => {
        return { width: "12%" };
      },
      formatter: (cell, row) => {
        return row.invoicePayments != null
          ? row.invoicePayments
              .map(
                (p) =>
                  `${moment(p.paymentDate).format(
                    "MM/DD/YYYY",
                  )} (${currencyFormatter("$", p.amountApplied)})`,
              )
              .join(", ")
          : "";
      },
    },
    {
      dataField: "invoiceStatusId",
      text: "Status",
      sort: true,
      headerStyle: () => {
        return { width: "20%" };
      },
      formatter: (cell, row) => {
        if (currentUser.systemRoleId == 2) {
          return (
            <CustomInput
              type="select"
              id={`invoiceStatusSelect${row.invoiceId}`}
              name={`invoiceStatusSelect${row.invoiceId}`}
              value={row.invoiceStatusId}
              onChange={(e) => {
                let copy = [...invoiceList];
                let item = copy.find((x) => x.invoiceId == row.invoiceId);
                if (item !== undefined) {
                  item.invoiceStatusId = e.target.value;
                  setInvoiceList(copy);
                  api.updateInvoice({ ...item }, currentUser.userId);
                }
              }}
            >
              {invoiceStatusList
                .filter((x) => x.invoiceStatusId >= 0)
                .map((p) => {
                  return (
                    <option key={p.invoiceStatusId} value={p.invoiceStatusId}>
                      {p.name}
                    </option>
                  );
                })}
            </CustomInput>
          );
        } else {
          let sts = invoiceStatusList.find(
            (x) => x.invoiceStatusId == row.invoiceStatusId,
          );
          return sts != undefined && sts != null ? sts.name : "";
        }

        // let bg = "",
        //   text = "";
        // if (row.invoiceStatusId == 0) {
        //   bg = "orange";
        //   text = "Draft";
        // } else if (row.invoiceStatusId == 1) {
        //   bg = "green";
        //   text = "Final";
        // } else {
        //   bg = "green";
        //   text = "Submitted";
        // }
        // return (
        //   <label
        //     style={{
        //       backgroundColor: bg,
        //       padding: "2px",
        //       borderRadius: "3px",
        //       color: "white",
        //     }}
        //   >
        //     {text}
        //   </label>
        // );
      },
    },
  ];
  const expandRow = {
    renderer: (row) => (
      <div className="table-responsive">
        <BootstrapTable
          bootstrap4
          keyField="invoiceId"
          data={row.invoiceList}
          columns={invoiceColumns}
        />
      </div>
    ),
    // expanded: this.state.expandedIndexes,
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <FontAwesomeIcon style={{ cursor: "pointer" }} icon={faMinus} />;
      }
      return <FontAwesomeIcon style={{ cursor: "pointer" }} icon={faPlus} />;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <FontAwesomeIcon style={{ cursor: "pointer" }} icon={faMinus} />;
      }
      return <FontAwesomeIcon style={{ cursor: "pointer" }} icon={faPlus} />;
    },
  };
  const partnerRowStyle = (row, rowIndex) => {
    const style = {};

    if (row.invoiceList !== undefined) {
      style.backgroundColor = "darkred";
      style.fontWeight = "bold";
      // style.fontSize='1.2em';
      style.color = "#fff";
    }

    return style;
  };
  const defaultSorted = [
    {
      dataField: "partnershipName",
      order: "asc",
    },
  ];

  return (
    <Fragment>
      <PageTitle heading="Invoices" />
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Fragment>
          <Row>
            {currentUser.systemRoleId == 2 && (
              <Col
                md="12"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    className="mb-2 mr-2"
                    color="primary"
                    onClick={() => goToInvoice(-1)}
                  >
                    Create New Invoice
                  </Button>
                  <Button
                    className="mb-2 mr-2"
                    color="primary"
                    onClick={togglePushInvoicesToQuickBooksModal}
                    disabled={isSyncingQuickBooks || quickbooksDisabled}
                  >
                    Send Invoices to QB
                  </Button>
                </div>
                <Button
                  className="mb-2 mr-2"
                  color="primary"
                  onClick={toggleGenerateInvoicesModal}
                >
                  Generate Monthly Invoices
                </Button>
              </Col>
            )}
          </Row>

          <Row>
            <Col md="3">
              {partnershipList.length > 0 && (
                <CustomInput
                  type="select"
                  id="partnershipSelect"
                  name="partnershipSelect"
                  value={selectedPartnershipId}
                  onChange={onPartnerSelectionChange}
                >
                  <option key={0} value={-1}>
                    All{" "}
                    {currentUser.entityRoleId == 1 ? "Law Firms" : "Clients"}
                  </option>
                  {partnershipList.map((p) => {
                    return (
                      <option key={p.partnershipId} value={p.partnershipId}>
                        {p.partnershipName}
                      </option>
                    );
                  })}
                </CustomInput>
              )}
            </Col>
            <Col md="3">
              <CustomInput
                type="select"
                id="outstandingAmount"
                name="outstandingAmount"
                value={outstandingAmountFilter}
                onChange={onOutstandingAmountFilterChange}
              >
                <option value={-1}>All Amounts</option>
                <option value={0}>Zero</option>
                <option value={1}>Higher than Zero</option>
              </CustomInput>
            </Col>
            <Col md="3">
              <CustomInput
                type="select"
                id="statusSelect"
                name="statusSelect"
                value={selectedInvoiceStatus}
                onChange={onSelectedInvoiceStatusChange}
              >
                {invoiceStatusList.map((s) => {
                  return (
                    <option key={s.invoiceStatusId} value={s.invoiceStatusId}>
                      {s.name}
                    </option>
                  );
                })}
              </CustomInput>
            </Col>
            <Col md="3">
              {reviewerList.length > 0 && (
                <CustomInput
                  type="select"
                  id="reviewerList"
                  name="reviewerList"
                  value={selectedReviewer}
                  onChange={onSelectedReviewerChange}
                >
                  {reviewerList.map((r) => {
                    return (
                      <option key={r} value={r}>
                        {r}
                      </option>
                    );
                  })}
                </CustomInput>
              )}
            </Col>
          </Row>
          <Row>
            {matterList.length > 0 && (
              <Col md="3">
                <div className="form-group">
                  <Label>Matter</Label>
                  <CustomInput
                    type="select"
                    id="matterSelect"
                    name="matterSelect"
                    value={selectedMatterId}
                    onChange={onMatterSelectionChange}
                  >
                    <option key={0} value={-1}>
                      All Matters
                    </option>
                    {matterList.map((p) => {
                      return (
                        <option key={p.matterId} value={p.matterId}>
                          {p.matterName}
                        </option>
                      );
                    })}
                  </CustomInput>
                </div>
              </Col>
            )}
            <Col md="3">
              <div className="form-group">
                <Label>Start Date</Label>
                <DatePicker
                  selected={startDate}
                  onChange={(e) => {
                    let date = e;
                    setStartDate(date);
                  }}
                  className="form-control"
                />
              </div>
            </Col>
            <Col md="3">
              <div className="form-group">
                <Label>End Date</Label>
                <DatePicker
                  selected={endDate}
                  onChange={(e) => {
                    let date = e;
                    setEndDate(date);
                  }}
                  className="form-control"
                />
              </div>
            </Col>
            <Col
              md="3"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Button color="primary" onClick={onApplyFilters}>
                Apply Filters
              </Button>
            </Col>
          </Row>

          <Row>
            <Col>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="search"
                  placeholder="Invoice number..."
                  className="form-control leguard-search-input"
                  value={invoiceNumberFilter}
                  onChange={(e) => setInvoiceNumberFilter(e.target.value)}
                  style={{ width: "300px" }}
                />
                <Button color="primary" onClick={searchByInvoiceNumber}>
                  Find Invoice
                </Button>
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: "30px" }}>
            <Col md="12">
              <Card className="main-card mb-3">
                <CardBody>
                  {/* <input
                    type="search"
                    placeholder="Invoice number..."
                    className="form-control leguard-search-input"
                    value={invoiceNumberFilter}
                    onChange={(e) => setInvoiceNumberFilter(e.target.value)}
                    style={{ width: "300px" }}
                  /> */}
                  <div className="table-responsive">
                    <BootstrapTable
                      bootstrap4
                      striped
                      bordered={false}
                      keyField="partnershipId"
                      data={invoiceGridList}
                      columns={columns}
                      defaultSorted={defaultSorted}
                      expandRow={expandRow}
                      rowStyle={partnerRowStyle}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Fragment>
      )}
      <GenerateInvoicesModal
        isOpen={showGenerateInvoicesModal}
        toggleModal={toggleGenerateInvoicesModal}
        partnershipList={partnershipList}
        reloadData={loadInvoices}
      />
      <QuickBooksLoadingModal
        isLoading={isSyncingQuickBooks}
        error={quickBooksError}
        navigateToQuickBooksPage={() => history.push("/quickbooks")}
      />

      <PushInvoicesToQuickbooksModal
        isOpen={showPushInvoicesToQuickBooksModal}
        toggleModal={togglePushInvoicesToQuickBooksModal}
        invoiceList={invoiceList}
        invoiceStatusList={invoiceStatusList}
        entity={entity}
        reloadData={loadInvoices}
        props={props}
        isLoading={isLoading}
      />
    </Fragment>
  );
}

export default InvoiceList;
